<template>
  <a-modal
    v-model:visible="isOpen"
    title="发送消息"
    @cancel="handleCancel"
    @ok="handleSend"
    okText="发送"
    cancelText="关闭"
    width="1200px"
    :maskClosable="false"
  >
  <template #footer>
    <a-button key="back" @click="handleCancel">关闭</a-button>
    <a-button key="submit" type="primary"  @click="handleOpenForbid">解除双向</a-button>
    <a-button key="submit" type="primary"  @click="handleSend">用户名发送</a-button>
    <a-button key="submit" type="primary"  @click="handleIDSend">ID发送</a-button>
  </template>
    <div class="message-container">
      <!-- 左侧：发送账号区域 -->
      <div class="account-list">
        <h3>发送账号</h3>
        <a-form-item>
          <a-select
            v-model:value="formState.sender"
            placeholder="请选择发送者"
            style="width: 100%"
            @change="handleSenderChange"
            @focus="handleSenderFocus"
          >
            <a-select-option
              v-for="sender in senders"
              :key="sender.strAccount"
              :value="sender.strAccount"
            >
              {{ sender.strNickName }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>

      <!-- 中间：接收账号列表 -->
      <div class="receiver-list">
        <h3>接收账号</h3>
        <!-- 添加指定账号输入框 -->
        <div class="specify-account">
          <a-input-group compact>
            <a-input
              v-model:value="specifiedAccount"
              placeholder="请输入指定账号"
              style="width: calc(100% - 80px)"
              @pressEnter="handleAddSpecifiedAccount"
            />
            <a-button type="primary" @click="handleAddSpecifiedAccount">添加</a-button>
          </a-input-group>
        </div>
        <div class="select-buttons">
          <a-button size="small" @click="handleBatchSelect(100)">选择100条</a-button>
          <a-button size="small" @click="handleBatchSelect(500)" style="margin-left: 8px">选择500条</a-button>
          <a-button size="small" @click="handleCancelSelect" style="margin-left: 8px" type="danger">取消选择</a-button>
        </div>
        <a-form-item style="margin-top: 8px">
          <a-select
            v-model:value="formState.selectedTargets"
            mode="multiple"
            placeholder="请选择接收者"
            style="width: 100%"
            @change="handleSelectChange"
            :maxTagCount="10"
            :autoClearSearchValue="true"
            :filterOption="filterOption"
            :showSearch="true"
            optionFilterProp="children"
            :options="receivers.map(receiver => ({
              value: receiver.strAccount,
              label: receiver.strNickName
            }))"
          />
        </a-form-item>
      </div>


      <!-- 接收数字ID -->
      <div class="receiver-list">
        <h3>接收数字ID</h3>
        <!-- 添加指定数字ID输入框 -->
        <div class="specify-account">
          <a-input-group compact>
            <a-input
              v-model:value="specifiedId"
              placeholder="请输入指定数字ID"
              style="width: calc(100% - 80px)"
              @pressEnter="handleAddSpecifiedID"
            />
            <a-button type="primary" @click="handleAddSpecifiedID">添加</a-button>
          </a-input-group>
        </div>
        <div class="select-buttons">
          <a-button size="small" @click="handleBatchSelectID(100)">选择100条</a-button>
          <a-button size="small" @click="handleBatchSelectID(500)" style="margin-left: 8px">选择500条</a-button>
          <a-button size="small" @click="handleCancelSelectID" style="margin-left: 8px" type="danger">取消选择</a-button>
        </div>
        <a-form-item style="margin-top: 8px">
          <a-select
            v-model:value="formStateID.selectedTargets"
            mode="multiple"
            placeholder="请选择接收者"
            style="width: 100%"
            @change="handleSelectChangeId"
            :maxTagCount="15"
            :autoClearSearchValue="true"
            :filterOption="filterOption"
            :showSearch="true"
            optionFilterProp="children"
            :options="receiverIds.map(receiver => ({
              value: receiver.strTelegramNo,
              label: receiver.strTelegramNo
            }))"
          />
        </a-form-item>
      </div>
 

      <!-- 右侧：消息内容区域 -->
      <div class="message-content">
        <h3>消息内容</h3>
        
        <!-- 固定工具栏 -->
        <div class="format-toolbar">
          <a-button-group>
            <a-button @click="formatText.bold" title="粗体">B</a-button>
            <a-button @click="formatText.italic" title="斜体">I</a-button>
            <a-button @click="formatText.underline" title="下划线">U</a-button>
            <a-button @click="formatText.strikethrough" title="删除线">S</a-button>
            <a-button @click="formatText.code" title="行内代码">{}</a-button>
            <a-button @click="formatText.codeblock" title="代码块">{ }</a-button>
            <a-button @click="formatText.link" title="添加链接">🔗</a-button>
            <a-button @click="formatText.spoiler" title="隐藏文本">��</a-button>
            <a-button @click="formatText.quote" title="引用">"</a-button>
          </a-button-group>
        </div>

        <a-textarea
          v-model:value="formState.message"
          placeholder="请输入消息内容"
          :rows="10"
          :maxlength="100000"
        />
        <!-- 消息类型选择 -->
        <div class="send-mode">
          <a-radio-group v-model:value="formState.messageType">
            <a-radio :value="1">普通消息</a-radio>
            <a-radio :value="2">POSTMAN消息</a-radio>
          </a-radio-group>
        </div>
      </div>
    </div>

    <!-- 链接编辑对话框 -->
    <a-modal
      v-model:visible="linkModalVisible"
      title="添加链接"
      @ok="handleLinkConfirm"
      okText="确定"
      cancelText="取消"
    >
      <a-form :model="linkForm" layout="vertical">
        <a-form-item label="链接文字">
          <a-input v-model:value="linkForm.text" placeholder="请输入链接显示的文字" />
        </a-form-item>
        <a-form-item label="链接地址">
          <a-input v-model:value="linkForm.url" placeholder="请输入链接地址" />
        </a-form-item>
      </a-form>
    </a-modal>
    
  </a-modal>
</template>

<style scoped>
.message-container {
  display: flex;
  gap: 16px;
  height: 500px;
}

.account-list {
  flex: 0.8;  /* 减小发送账号区域的宽度 */
  border: 1px solid #e8e8e8;
  padding: 10px;
  border-radius: 4px;
}

.receiver-list {
  flex: 1.2;  /* 适当调整接收账号区域的宽度 */
  border: 1px solid #e8e8e8;
  padding: 10px;
  border-radius: 4px;
}

.message-content {
  flex: 2;
  border: 1px solid #e8e8e8;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

h3 {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
  font-size: 14px;
  color: #333;
}

.select-buttons {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
}

.send-mode {
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid #e8e8e8;
}

/* 调整表单项间距 */
:deep(.ant-form-item) {
  margin-bottom: 12px;
}

/* 调整选择框内部样式 */
:deep(.ant-select-selector) {
  border-radius: 4px;
}

.message-actions {
  margin-bottom: 8px;
  display: flex;
  gap: 8px;
}

.format-toolbar {
  margin-bottom: 8px;
  padding: 8px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fafafa;
}

.format-toolbar .ant-btn {
  padding: 0 8px;
  font-size: 12px;
  height: 24px;
  line-height: 22px;
  margin-right: 4px;
}

.format-toolbar .ant-btn:hover {
  color: #1890ff;
  border-color: #1890ff;
}
</style>

<script lang="ts" setup>
import { ref, reactive, defineProps, defineEmits, computed, watch, onBeforeUnmount, shallowRef, h } from 'vue'
import { TelegramClient } from "@/websocket/Client";
import { message } from "ant-design-vue";

interface Account {
  strTelegramNo: string; // TelegramNo
  strAccount: string; // Account
  strNickName: string; // NickName
}

interface SenderAccount {
  strAccount: string;
  strStatus: string;
}

const props = defineProps<{
  visible: boolean;
}>();

const emit = defineEmits<{
  (e: "update:visible", visible: boolean): void;
  (e: "success"): void;
}>();

// 使用计算属性处理 visible 状态
const isOpen = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value),
});

const senders = ref<Account[]>([]);
const receivers = ref<Account[]>([]);
const receiverIds = ref<Account[]>([]);
const formState = reactive({
  sender: "",
  selectedTargets: [] as string[],
  message: "",
  messageType: 1,
});

const formStateID = reactive({
  sender: "",
  selectedTargets: [] as string[],
  message: "",
  messageType: 1,
});

// 监听模态框显示状态，当显示时获取账号列表
watch(
  () => props.visible,
  async (newVisible) => {
    if (newVisible) {
      await fetchAccountList();
      formState.selectedTargets = []; // 重置选择状态
      formStateID.selectedTargets = []; // 重置选择状态
    }
  }
);

// 获取账号列表
const fetchAccountList = async () => {
  console.log("fetchAccountList");
  try {
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }
    const client = TelegramClient.getInstance();

    const sendersResponse = await client.getAccountList(username);
    if (sendersResponse && Array.isArray(sendersResponse.list)) {
      senders.value = sendersResponse.list
        .filter((sender: SenderAccount) => sender.strStatus === "3")
        .map((sender: SenderAccount) => ({
          strTelegramNo: sender.strAccount,
          strAccount: sender.strAccount,
          strNickName: sender.strAccount,
        }));
    }

    await refreshReceiverList();
  } catch (error) {
    console.error("获取账号列表错误:", error);
    message.error("获取账号列表失败");
  }
};

// 添加刷新发送者列表的方法
// 同样更新刷新方法
const refreshSendersList = async () => {
  try {
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }
    const client = TelegramClient.getInstance();
    const response = await client.getAccountList(username);

    if (response && Array.isArray(response.list)) {
      senders.value = response.list
        .filter((sender: SenderAccount) => sender.strStatus === "3")
        .map((sender: SenderAccount) => ({
          strTelegramNo: sender.strAccount,
          strAccount: sender.strAccount,
          strNickName: sender.strAccount,
        }));

      console.log("刷新后的发送者列表:", senders.value);
      if (senders.value.length === 0) {
        message.warning("没有可用的发送者账号");
      }
    }
  } catch (error) {
    console.error("刷新发送者列表错误:", error);
    message.error("刷新发送者列表失败");
  }
};

// 修改发送者选择框的点击事件
const handleSenderFocus = async () => {
  if (senders.value.length === 0) {
    await refreshSendersList();
  }
};

// 加发送者选择处理函数
const handleSenderChange = (value: string) => {
  formState.sender = value;
};

 
const handleOpenForbid = async() => {
  console.log("handleOpenForbid");
  const client = TelegramClient.getInstance();
  const account = localStorage.getItem("username") || "";

  if (!formState.sender) {
    message.warning("请选择发送者");
    return;
  }
  const result = await client.sendOpenForbid(
      account,
      formState.sender,
      ""
    );
    if (result && result.code === 1) {
      const succesMsg = result?.reason || "解除成功";
      message.success(succesMsg);
      //emit("update:visible", false);
    } else {
      const errorMsg = result?.reason || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
    
};

const handleCancel = () => {
  console.log("handleCancel");
  resetForm();
  emit("update:visible", false);
};


//handleIDSend
const handleIDSend = async () => {
  console.log("handleIDSend");
  if (!formState.sender) {
    message.warning("请选择发送者");
    return;
  }

  if (!formStateID.selectedTargets.length) {
    message.warning("请选择至少一个接收者");
    return;
  }

  if (!formState.message.trim()) {
    message.warning("请输入消息内容");
    return;
  }

  try {
    const messageText = formState.message;
    const client = TelegramClient.getInstance();
    const account = localStorage.getItem("username") || "";
    // 修改这部分逻辑，直接使用账号创建目标对象
    const targets = formStateID.selectedTargets.map((targetId) => {
      // 尝试从receivers中查找账号信息，如果找不到就直接使用输入的账号
      const receiver = receivers.value.find(
        (acc) => acc.strTelegramNo === targetId
      );
      return { 
        Id: receiver ? Number(receiver.strTelegramNo) : Number(targetId) 
      };
    });
    //Id
    const result = await client.sendMessage(
      account,
      formState.sender,
      targets,
      messageText,
      formState.messageType
    );

    console.log("handleSend");

    if (result && result.code === 1) {
      message.success("发送成功");
      emit("success");
      resetForm();
      //emit("update:visible", false);
    } else {
      const errorMsg = result?.message || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
  } catch (error) {
    console.error("发送消息错误:", error);
    message.error(
      `发送失败: ${error instanceof Error ? error.message : String(error)}`
    );
  }
};



const handleSend = async () => {
  console.log("handleSend");
  if (!formState.sender) {
    message.warning("请选择发送者");
    return;
  }

  if (!formState.selectedTargets.length) {
    message.warning("请选择至少一个接收者");
    return;
  }

  if (!formState.message.trim()) {
    message.warning("请输入消息内容");
    return;
  }

  try {
    const messageText = formState.message;
    const client = TelegramClient.getInstance();
    const account = localStorage.getItem("username") || "";
    // 修改这部分逻辑，直接使用账号创建目标对象
    const targets = formState.selectedTargets.map((targetId) => {
      // 尝试从receivers中查找账号信息，如果找不到就直接使用输入的账号
      const receiver = receivers.value.find(
        (acc) => acc.strAccount === targetId
      );
      return { 
        name: receiver ? receiver.strAccount : targetId 
      };
    });

    const result = await client.sendMessage(
      account,
      formState.sender,
      targets,
      messageText,
      formState.messageType
    );

    console.log("handleSend");

    if (result && result.code === 1) {
      message.success("发送成功");
      emit("success");
      resetForm();
      //emit("update:visible", false);
    } else {
      const errorMsg = result?.message || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
  } catch (error) {
    console.error("发送消息错误:", error);
    message.error(
      `发送失败: ${error instanceof Error ? error.message : String(error)}`
    );
  }
};

const resetForm = () => {
  Object.assign(formState, {
    sender: "",
    selectedTargets: [],
    selectedTargetIds:[],
    //message: "",
    messageType: 1,
  });
};

const handleSelectChange = (selectedValues: string[]) => {
  if (Array.isArray(selectedValues)) {
    formState.selectedTargets = selectedValues.filter(value => value !== '');
  } else {
    formState.selectedTargets = [];
  }
  
  if (formState.selectedTargets.length === 0) {
    message.info('请至少选择一个接收者');
  }
  console.log("handleSelectChange")

};


const handleSelectChangeId = (selectedValues: string[]) => {
  if (Array.isArray(selectedValues)) {
    formStateID.selectedTargets = [];
    let list = selectedValues.filter(value => value !== '');
    for (let i = 0; i < list.length; i++) {
        const element = list[i];
        console.log("handleSelectChangeId "+element);
        const id = element.trim();
        formStateID.selectedTargets.push(id);
     }
    //formStateID.selectedTargets = selectedValues.filter(value => value !== '');
  } else {
    formStateID.selectedTargets = [];
  }
  
  if (formStateID.selectedTargets.length === 0) {
    message.info('请至少选择一个接收者');
  }
  console.log("handleSelectChangeId")

};



// 添加刷新接收者列表的方法
const refreshReceiverList = async () => {
  try {
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }
    const client = TelegramClient.getInstance();
    const response = await client.getPrivateChatList(username, "session", 1);

    if (response && Array.isArray(response)) {

      let list = response.map((receiver: any) => ({
        strTelegramNo: receiver.strTelegramNo,
        strAccount: receiver.strAccount,
        strNickName: receiver.strNickName || receiver.strAccount,
      }));
      receivers.value = list.filter((value) => value.strAccount != "");
      receiverIds.value = list.filter((value) => value.strTelegramNo != "");
      console.log("刷新后的接收者列表:", receivers.value);
      console.log("刷新后的接收者数字ID列表:", receiverIds.value);
      if (receivers.value.length === 0) {
        message.warning("没有可用的接收者账号");
      }
    }
  } catch (error) {
    console.error("刷新接收者列表错误:", error);
    message.error("刷新接收者列表失败");
  }
};

// 添加过滤函数
const filterOption = (inputValue, option) => {
  console.log("filterOption");
  if (!inputValue || inputValue.length === 0) {
    return true;
  }

  const inputFirstChar = inputValue.charAt(0).toLowerCase();
  const valueFirstChar = option.value.charAt(0).toLowerCase(); // 使用 option.value
  return valueFirstChar === inputFirstChar;

};


// 添加批量选择函数
const handleBatchSelect = (count: number) => {
  const currentSelected = new Set(formState.selectedTargets);
  const availableReceivers = receivers.value
    .filter(receiver => !currentSelected.has(receiver.strAccount))
    .map(receiver => receiver.strAccount);

  // 计算还需要选择多少条
  const needToSelect = count;
  const newSelected = availableReceivers.slice(0, needToSelect);

  // 合并已选择的和新选择的
  formState.selectedTargets = [...currentSelected, ...newSelected];

  // 提示实际选择数量
  const actualSelected = formState.selectedTargets.length;
  message.info(`已选择 ${actualSelected} 条记录`);
};

const handleBatchSelectID = (count: number) => {
  const currentSelected = new Set(formStateID.selectedTargets);
  const availableReceivers = receiverIds.value
    .filter(receiver => !currentSelected.has(receiver.strTelegramNo))
    .map(receiver => receiver.strTelegramNo);

  // 计算还需要选择多少条
  const needToSelect = count;
  const newSelected = availableReceivers.slice(0, needToSelect);

  // 合并已选择的和新选择的
  formStateID.selectedTargets = [...currentSelected, ...newSelected];

  // 提示实际选择数量
  const actualSelected = formStateID.selectedTargets.length;
  message.info(`已选择 ${actualSelected} 条记录`);
};



// 添加取消选择函数
const handleCancelSelect = () => {
  formState.selectedTargets = [];
  message.info('已清除所有选择');
};

const handleCancelSelectID = () => {
  formStateID.selectedTargets = [];
  message.info('已清除所有选择');
};


// 添加链接编辑对话框的状态
const linkModalVisible = ref(false)
const linkForm = reactive({
  text: '',
  url: ''
})

// 修改格式化方法
const formatText = {
  bold: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`*${selected}*`, start, end);
  },

  italic: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`_${selected}_`, start, end);
  },

  underline: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`__${selected}__`, start, end);
  },

  strikethrough: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`~${selected}~`, start, end);
  },

  code: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`${selected}\``, start, end);
  },

  codeblock: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`\`\`\n${selected}\n\`\`\``, start, end);
  },

  spoiler: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`||${selected}||`, start, end);
  },

  quote: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    // 处理多行引用
    const formatted = selected.split('\n').map(line => `> ${line}`).join('\n');
    insertText(formatted, start, end);
  },

  link: () => {
    const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const text = textarea.value;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    linkForm.text = text.substring(start, end);
    linkForm.url = '';
    
    // 保存当前光标位置
    const currentPos = { start, end };
    (textarea as any).savedPos = currentPos;
    
    // 显示链接编辑对话框
    linkModalVisible.value = true;
  }
};

// 辅助函数：插入文本
const insertText = (newText: string, start: number, end: number) => {
  const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const text = textarea.value;
  formState.message = text.substring(0, start) + newText + text.substring(end);
  
  // 恢复焦点并更新光标位置
  textarea.focus();
  const newPosition = start + newText.length;
  textarea.setSelectionRange(newPosition, newPosition);
};

// 处理链接确认
const handleLinkConfirm = () => {
  const textarea = document.querySelector('.message-content textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const { start, end } = (textarea as any).savedPos || { start: 0, end: 0 };
  const linkMarkdown = `[${linkForm.text}](${linkForm.url})`;
  
  insertText(linkMarkdown, start, end);
  linkModalVisible.value = false;
  console.log("dadf");
};

// 添加指定账号相关的响应式变量和方法
const specifiedAccount = ref('');
const specifiedId = ref('');
const handleAddSpecifiedAccount = () => {
  const account = specifiedAccount.value.trim();
  if (!account) {
    message.warning('请输入账号');
    return;
  }

  // 检查账号是否已经在选中列表中
  if (formState.selectedTargets.includes(account)) {
    message.warning('该账号已在列表中');
    return;
  }

  // 添加到选中列表
  formState.selectedTargets.push(account);
};



const handleAddSpecifiedID = () => {
  const id = specifiedId.value.trim();
  if (!id) {
    message.warning('请输入数字ID');
    return;
  }

  // 检查账号是否已经在选中列表中
  if (formStateID.selectedTargets.includes(id)) {
    message.warning('该账号已在列表中');
    return;
  }

  // 添加到选中列表
  formStateID.selectedTargets.push(id);
};


</script>
